import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  label: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 500,
  },

  title: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
  },

  value: {
    fontFamily: "Manrope",
    fontSize: "36px",
    fontWeight: 700,
  },
}));

export default useStyles;
